import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Select from "react-select";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import {
  getAllFiles,
  getLanguages,
  addLanguage,
  getSetting,
} from "../../api/api";
// import { UserLang } from "../../store/userStore";
import Loader from "../loader/loader";
import ToolTip from "../tooltip/tooltip";

const Language = (props) => {
  const menuPic = [
    {
      value: "ar",
      label: "Arabic",
    },
    {
      value: "be",
      label: "Belarusian",
    },
    {
      value: "bg",
      label: "Bulgarian",
    },
    {
      value: "cs",
      label: "Czech",
    },
    {
      value: "cy",
      label: "Welsh",
    },
    {
      value: "da",
      label: "Danish",
    },
    {
      value: "de",
      label: "German",
    },
    {
      value: "el",
      label: "Greek",
    },
    {
      value: "en",
      label: "English",
    },
    {
      value: "eo",
      label: "Esperanto",
    },
    {
      value: "es",
      label: "Spanish",
    },
    {
      value: "et",
      label: "Estonian",
    },
    {
      value: "fi",
      label: "Finnish",
    },
    {
      value: "fr",
      label: "French",
    },
    {
      value: "ga",
      label: "Irish",
    },
    {
      value: "gd",
      label: "Scottish Gaelic",
    },
    {
      value: "hi",
      label: "Hindi",
    },
    {
      value: "hu",
      label: "Hungarian",
    },
    {
      value: "hy",
      label: "Armenian",
    },
    {
      value: "id",
      label: "Indonesian",
    },
    {
      value: "is",
      label: "Icelandic",
    },
    {
      value: "it",
      label: "Italian",
    },

    {
      value: "ja",
      label: "Japanese",
    },
    {
      value: "ko",
      label: "Korean",
    },
    {
      value: "lt",
      label: "Lithuanian",
    },
    {
      value: "lv",
      label: "Latvian",
    },
    {
      value: "mk",
      label: "Macedonian",
    },
    {
      value: "ml",
      label: "Malayalam",
    },
    {
      value: "mn",
      label: "Mongolian",
    },
    {
      value: "mo",
      label: "Moldavian",
    },
    {
      value: "ne",
      label: "Nepali",
    },
    {
      value: "nl",
      label: "Dutch",
    },
    {
      value: "nn",
      label: "Norwegian",
    },
    {
      value: "pl",
      label: "Polish",
    },
    {
      value: "pt",
      label: "Portuguese",
    },
    {
      value: "ro",
      label: "Romanian",
    },
    {
      value: "ru",
      label: "Russian",
    },
    {
      value: "sk",
      label: "Slovak",
    },
    {
      value: "sl",
      label: "Slovenian",
    },
    {
      value: "sq",
      label: "Albanian",
    },
    {
      value: "sr",
      label: "Serbian",
    },
    {
      value: "sv",
      label: "Swedish",
    },
    {
      value: "th",
      label: "Thai",
    },
    {
      value: "tr",
      label: "Turkish",
    },
    {
      value: "uk",
      label: "Ukrainian",
    },
    {
      value: "vi",
      label: "Vietnamese",
    },
    {
      value: "yi",
      label: "Yiddish",
    },
    {
      value: "zh",
      label: "Chinese",
    },
  ];
  const menu_data = {
    languageid: "",
    languageRef: "",
    landefault: "",
    lanUrl: "",
  };

  const [allIcon] = useState(menuPic);
  const [characters, updateCharacters] = useState([]);
  const [allFiles, setAllFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  const [change, setChange] = useState(false);
  const [pChange, setPChange] = useState(false);
  const [setting, setSetting] = useState([]);
  const [final, setFinal] = useState([menu_data]);
  const [languageid, setLanguageid] = useState("");
  const [languageRef, setLanguageRef] = useState("");
  const [landefault, setLandefault] = useState(false);
  const [lanUrl, setLanUrl] = useState("");
  const [lan] = useState("ltr");
  // const lan = UserLang.useState((s) => s.lan);

  useEffect(() => {
    const settingDetail = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */
      const result = await getSetting().then(
        (result) => {
          setSetting(result.data);
          setLoading(false);
        },
        (error) => {
          // const obj = {'status':error.response.data.error.status, 'message':error.response.data.error.message};
          // setColorCount(obj.message);
          // setColorStatus(obj.status);
          setLoading(false);
        }
      );
    };

    const getFile = async () => {
      try {
        const appl = await getAllFiles(100, 0);

        const images = appl.data.images;
        const opt = images.map((item) => ({
          value: item.filekey,
          label: item.fileName,
          key: item.filekey,
          name: item.fileName,
          id: item._id,
        }));

        setAllFiles(opt);
      } catch (error) {}
    };

    const getLanguage = async () => {
      setLoading(true);
      try {
        const appl = await getLanguages();

        const newArray = appl.data;
        if (appl.data.length !== 0) {
          appl.data.languages.map((item) =>
            item.landefault === true ? setDisable(true) : setDisable(false)
          );
          if (!setting.multiLanguage === true) {
            appl.data.languages.map((item) =>
              item.landefault === true
                ? setPChange(true) & setChange(true)
                : setChange(false) & setPChange(false)
            );
            // setChange(true);
            setLandefault(true);
            setDisable(true);
          }

          setFinal(newArray);
          newArray.languages !== null
            ? updateCharacters(newArray.languages)
            : updateCharacters([]);
        }
        setLoading(false);
      } catch (error) {
        toastr.error("Unable to Load Data", "Error");
        setLoading(false);
      }
    };
    getFile();
    getLanguage();
    settingDetail();
  }, [setting.multiLanguage]);

  const onChangePage = (value, evt) => {
    setLanguageid(value.value);
    setLanguageRef(value.label);
    // setChange(false);
  };
  const reorderArray = (items) => {
    const newItems = items.map((item, index) => {
      // if(!item.landefault===true)
      item.menuOrder = index + 1;
      //    else

      return item;
    });
    updateCharacters(newItems);
  };
  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(characters);
    const [reorderedItem] = items.splice(result.source.index, 1);

    if (reorderedItem.landefault !== true && result.destination.index === 0)
      items.splice(result.destination.index + 1, 0, reorderedItem);
    else if (reorderedItem.landefault !== true)
      items.splice(result.destination.index, 0, reorderedItem);
    else items.splice(0, 0, reorderedItem);
    reorderArray(items);
  };

  //    const setDefault =(result)=>
  //     {
  //         const items = Array.from(characters);
  //         const [reorderedItem] = items.splice(items.length-1, 1);
  //
  //         items.splice(0, 0, reorderedItem);

  //     }

  const handlePublish = async (event) => {
    const newArray = final;
    newArray.languages = characters;
    setFinal(newArray);
    event.preventDefault();
    setLoading(true);
    /* eslint-disable no-unused-vars */
    final.languages.map((item) =>
      item.landefault === true ? setDisable(true) : setDisable(false)
    );

    const result = await addLanguage(final).then(
      (result) => {
        toastr.success("Successfully Saved", "Success");

        setPChange(true);
        setLoading(false);
      },
      (error) => {
        toastr.error(error, "Error");
        setLoading(false);
      }
    );
  };

  //    const handleChange =(event)=>
  //    {
  //       if(event.target.name==="menuTitle")
  //       {
  //         setmenuTitle(event.target.value);

  //       }
  //    }
  const onChangeItemed = (value, event) => {
    setLanUrl(value.value);
    //    setChange(false);
  };

  const updateVisiblity = (value, event) => {
    setLandefault(true);
  };

  const checkValueExist = (value, type) => {
    return characters.some(function (el) {
      if (type === "languageRef") {
        return el.languageRef === value;
      } else if (type === "lanUrl") {
        return el.lanUrl === value;
      }
      //  else if(type==="menuurlName")
      //  {
      //   return el.menuurlName === value;
      //  }
      else {
        return el.languageRef === value;
      }
    });
  };

  const handleSave = (evt) => {
    evt.preventDefault();

    const opt = {
      languageid: languageid,
      languageRef: languageRef,
      landefault: landefault,
      lanUrl: lanUrl,
      menuOrder: characters.length + 1,
    };

    if (
      !checkValueExist(opt.menuPage, "menuPage") &&
      !checkValueExist(opt.lanUrl, "lanUrl")
    ) {
      if (landefault === true) {
        let a = [];
        a.push(characters);
        a[0].unshift(opt);

        updateCharacters([...characters]);
        setLandefault(false);
        setDisable(true);
      } else updateCharacters([...characters, opt]);
      // setChange(true);

      if (!setting.multiLanguage === true) {
        final.languages.map((item) =>
          item.landefault === true
            ? setChange(true)
            : setChange(false) & setLandefault(true) & setDisable(true)
        );
        // setChange(true);
      }
    } else {
      toastr.error("Menu Title/Url Name/Page Already Exist", "Error");
    }
  };

  const handleRemove = (event, index) => {
    const removeId = index;
    event.preventDefault();
    const items = Array.from(characters);
    const removeItem = items.splice(index, 1);

    removeItem.landefault === true
      ? setDisable(true)
      : setDisable(false) && setLandefault(true);

    if (!setting.multiLanguage === true) {
      removeItem.landefault === true ? setPChange(true) : setPChange(false);
      removeItem.landefault === true ? setChange(true) : setChange(false);
      if (!removeItem.landefault === true) {
        setLandefault(true);
        setDisable(true);
      }

      // setChange(true);
    }

    reorderArray(items);
  };

  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Language
                  </h3>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <div className="row">
                          <div
                            className="col-md-4"
                            lan={lan === "rtl" ? "rtl" : "ltr"}
                          >
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              {lan === "rtl" && (
                                <ToolTip
                                  info={"Select language name"}
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              )}
                              &nbsp;Language Name&nbsp;
                              {!(lan === "rtl") && (
                                <ToolTip
                                  info={"Select language name"}
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              )}
                            </label>
                            <Select
                              name="pageId"
                              className={
                                lan === "rtl"
                                  ? "form-control inside-select float-right"
                                  : "form-control inside-select float-left"
                              }
                              options={allIcon}
                              onChange={(value, event) =>
                                onChangePage(value, event)
                              }
                            ></Select>
                          </div>
                          {/* <div className="col-md-4">
                            <div className="form-group">
                              <label style={{marginTop:"6px"}}>Language Name</label>
                              <input
                                type="text"
                                name="menuTitle"
                                className="form-control inside-form"
                                placeholder="Name..."
                                autoComplete="off"
                                onChange={handleChange} 
                              />
                            </div>
                          </div> */}

                          <div
                            className="col-md-4"
                            lan={lan === "rtl" ? "rtl" : "ltr"}
                          >
                            <div className="form-group">
                              <label
                                className={
                                  lan === "rtl" ? "float-right" : "float-left"
                                }
                              >
                                {lan === "rtl" && (
                                  <ToolTip
                                    info={
                                      "Select the default language file for the platform"
                                    }
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                                &nbsp;Language URL&nbsp;
                                {!(lan === "rtl") && (
                                  <ToolTip
                                    info={
                                      "Select the default language file for the platform"
                                    }
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                              </label>
                              <Select
                                name="menuIcon"
                                className={
                                  lan === "rtl"
                                    ? "form-control inside-select float-right"
                                    : "form-control inside-select float-left"
                                }
                                options={allFiles}
                                onChange={(value, event) =>
                                  onChangeItemed(value, event)
                                }
                              ></Select>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div
                              className="form-group"
                              style={{ padding: "0" }}
                            >
                              <label
                                className={
                                  lan === "rtl" ? "float-right" : "float-left"
                                }
                              >
                                {lan === "rtl" && (
                                  <ToolTip
                                    info={"Enable to set as default"}
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                                &nbsp;Default Language&nbsp;
                                {!(lan === "rtl") && (
                                  <ToolTip
                                    info={"Enable to set as default"}
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                                {}
                              </label>
                            </div>
                            <div className="form-group ">
                              <div
                                className="custom-control custom-switch"
                                dir={lan === "rtl" ? "rtl" : "ltr"}
                                style={{ paddingTop: "30px" }}
                              >
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  name={"landefault"}
                                  id={"landefault"}
                                  checked={landefault}
                                  onClick={(event) =>
                                    setLandefault(!landefault)
                                  }
                                  onChange={(e) => e.stopPropagation()}
                                  disabled={disable}
                                />
                                <label
                                  className={
                                    lan === "rtl"
                                      ? "float-right custom-control-label not-bold"
                                      : "float-left custom-control-label not-bold"
                                  }
                                  htmlFor={"landefault"}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  Default
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group">
                              <button
                                type="button"
                                className="btn btn-primary"
                                style={
                                  lan === "rtl"
                                    ? {
                                        width: "100px",
                                        marginTop: "20px",
                                        marginLeft: "6px",
                                        float: "left",
                                      }
                                    : {
                                        width: "100px",
                                        marginTop: "20px",
                                        marginRight: "6px",
                                        float: "right",
                                      }
                                }
                                onClick={handleSave}
                                disabled={languageid ? change : true}
                              >
                                Add
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-12">
                      <div className="row mb-2 mt-2"></div>
                      <div className="card-header" style={{ padding: "0px" }}>
                        <label>Language Container</label>
                      </div>
                      {characters ? (
                        <DragDropContext onDragEnd={handleOnDragEnd}>
                          <Droppable droppableId={"characters"}>
                            {(provided) => (
                              <ul
                                className="products-list product-list-in-card pl-2 pr-2"
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={{
                                  maxHeight: "450px",
                                  overflowY: "scroll",
                                }}
                              >
                                {characters.map((item, index) => (
                                  <Draggable
                                    key={item.languageid + item.menuOrder}
                                    draggableId={"item" + item.menuOrder}
                                    index={index}
                                  >
                                    {(provided) => (
                                      <li
                                        className="item"
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                      >
                                        <div
                                          className={
                                            lan === "rtl"
                                              ? "product-info float-right"
                                              : "product-info float-left"
                                          }
                                        >
                                          <span
                                            className={
                                              lan === "rtl"
                                                ? "badge badge-warning float-right"
                                                : "badge badge-warning float-left"
                                            }
                                          >
                                            {index + 1}
                                          </span>
                                          <label className="product-title ml-3">
                                            {item.languageRef}
                                          </label>
                                          <span
                                            className="product-description"
                                            style={
                                              lan === "rtl"
                                                ? { marginRight: "55px" }
                                                : { marginLeft: "55px" }
                                            }
                                          >
                                            {lan === "rtl"
                                              ? item.landefault +
                                                " : Default Language"
                                              : "Default Language : " +
                                                item.landefault}
                                          </span>
                                          <span
                                            className="product-description"
                                            style={
                                              lan === "rtl"
                                                ? { marginRight: "55px" }
                                                : { marginLeft: "55px" }
                                            }
                                          >
                                            {lan === "rtl"
                                              ? item.lanUrl + " : Language URL"
                                              : "Language URL : " + item.lanUrl}
                                          </span>
                                        </div>
                                        <div
                                          className="text-right"
                                          style={
                                            lan === "rtl"
                                              ? {
                                                  display: "inline",
                                                  float: "left",
                                                }
                                              : {
                                                  display: "inline",
                                                  float: "right",
                                                }
                                          }
                                        >
                                          <a
                                            className="btn btn-light btn-sm"
                                            href="#!"
                                            onClick={(event) =>
                                              handleRemove(event, index)
                                            }
                                          >
                                            <i className="fas fa-trash"></i>
                                          </a>
                                        </div>
                                      </li>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                              </ul>
                            )}
                          </Droppable>
                        </DragDropContext>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                {/* /.card-body */}
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <button
                        type="button"
                        className="btn btn-primary"
                        style={{
                          width: "100px",
                          marginRight: "25px",
                          float: "right",
                          marginBottom: "12px",
                        }}
                        onClick={handlePublish}
                        disabled={pChange}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default Language;
